export const setBooleanOption = (data: string | 'true' | 'false'): boolean => {
  if (data === 'true') return true;
  if (data === 'false') return false;
  return Boolean(data);
};
